import CommentInput from './CommentInput';
import CommentList from './CommentList';
import { Link } from 'react-router-dom';
import React from 'react';

const CommentContainer = props => {
  if (props.currentUser) {
    return (
      <>
        <div 
          style={{paddingBottom: "20px"}}>
          <list-errors errors={props.errors}></list-errors>
          <CommentInput slug={props.slug} currentUser={props.currentUser} authorizeCommentsBeforePublish={props.authorizeCommentsBeforePublish} />
        </div>
        <CommentList
          comments={props.comments}
          slug={props.slug}
          currentUser={props.currentUser}/>
      </>
    );
  } else {
    return (
      <>
        <p style={{textAlign: "center"}}>
          <Link to="/login">سجل دخول</Link>
          &nbsp;أو&nbsp;
          <Link to="/register">سجل مستخدم جديد</Link>
          &nbsp;لتعلق على هذه التدوينة
        </p>
        <CommentList
          comments={props.comments}
          slug={props.slug}
          currentUser={props.currentUser} />
      </>
    );
  }
};

export default CommentContainer;
